'use client';

import { ReactComponent as RockXLogo } from '#/assets/icons/logo/rockx.svg';
import { Button } from '#/components/ui/button';
import { cn } from '#/lib/utils';
import { LocaleSwitcher } from '#/modules/display/locale-switcher';
import { UserDropdown } from '#/modules/display/user-dropdown';
import { Menu } from 'lucide-react';
import { useAppSidebarStore } from './app-sidebar-store';

export function AppHeader() {
  const sidebar = useAppSidebarStore(state => state.sidebar);
  return (
    <header
      className={cn(
        'sticky z-20 top-0 shadow bg-[#111D3C] dark:bg-gray-900 w-auto dark'
      )}
    >
      <div className="container mx-auto h-17 flex items-center justify-between px-4">
        <div className="shrink-0 grow lg:grow-0">
          <RockXLogo className="w-32 h-8 text-white" />
        </div>
        <div
          className={cn('flex items-center justify-between gap-2', {
            hidden: sidebar?.isMobile,
          })}
        >
          <UserDropdown />
          <LocaleSwitcher />
        </div>
        <Button
          type="button"
          variant="ghost"
          size="icon"
          className={cn('rounded-full text-accent-foreground', {
            hidden: !sidebar?.isMobile,
          })}
          onClick={() => sidebar?.toggleSidebar()}
        >
          <Menu />
          <span className="sr-only">Toggle Sidebar</span>
        </Button>
      </div>
    </header>
  );
}
